import breaks from "../img/breakfast1.jpg";
import lunch from "../img/lunch1.jpg";
import dinner from "../img/dinner1.jpg";
import chicken from "../img/chicken1.jpg";
import biryani from "../img/biryani1.jpg";





const Datam = {
    cardDatam: [
        {
            img: breaks,
            title: "Breakfast Recipe",
            link : "/breakfast",
          

        },
        {
            img: lunch,
            title: "Lunch Recipe",
            link : "/lunch",

        },
        {
            img: dinner,
            title: "Dinner Recipe",
            link : "/dinner",

        },
        {
            img: chicken,
            title: "Chicken Recipe",
            link : "/chicken",

        },
        {
            img: biryani,
            title: "Biryani Recipe",
            link : "/biryani",

        },
    ],
}

export default Datam;
